import { Button, Upload, UploadFile } from 'antd';
import React, { useEffect, useState } from 'react';
import ModalUpdateImages from './ModalUpdateImages/ModalUpdateImages';
import ModalViewImages from './ModalUpdateImages/ModalViewImages';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import OrderManagerApi from 'apis/api/OrderManager';
import { useTranslation } from 'react-i18next';

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

interface IUploadImages {
  status?: any;
  data?: any;
  typeKeyOrder?: any;
  rowSelected?: any;
  //   dataAccountant: ISelectOption[];
}

export default function UploadImages(props: IUploadImages) {
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalView, setOpenModalView] = useState<boolean>(false);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);

  const [listHinh, setListHinh] = useState<UploadFile[]>([]);
  const [listHinhNew, setListHinhNew] = useState<UploadFile[]>([]);
  const [images1, setImages1] = useState<any>();
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setImages1(file);
    setPreviewOpen(true);
    setOpenModalView(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  // console.log(previewImage.split('data:image/png;base64,').join(''));
  const handleUpload = ({ file, fileList }) => {
    setListHinhNew([...fileList]);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // cần sửa lại này
  const getListImages = async () => {
    const arrayValue = [];
    for (let i = 0; i < props.rowSelected?.images?.length; i++) {
      arrayValue.push({
        uid: props.rowSelected.images[i].id,
        name: props.rowSelected.images[i].comment,
        status: 'done',
        url: process.env.REACT_APP_URL_AUTH + props.rowSelected.images[i].link
      });
    }
    setListHinh(arrayValue);
  };

  const callBackRefresh = () => {
    // gọi api lại
    try {
      OrderManagerApi.GetDetailOfOrder(props?.data?.maDonHang, props?.typeKeyOrder).then(res => {
        if (!res.data.error) {
          setListHinh(
            res?.data?.data?.images?.map(e => ({
              uid: e.id,
              name: e.comment,
              status: 'done',
              url: process.env.REACT_APP_URL_AUTH + e.link
            }))
          );
        }
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    // console.log('data', rowSelected?.images);
    getListImages();
  }, []);

  return (
    <>
      {openModalView && (
        <ModalViewImages
          isOpen={openModalView}
          base64={previewImage}
          images1={images1}
          listHinh={listHinh || []}
          listHinhNew={listHinhNew}
          data={props}
          status={props?.status}
          callBackClose={() => setOpenModalView(false)}
          callBackRefresh={callBackRefresh}
          // callBackCreate={callBackCreate}
        />
      )}

      {openModal && (
        <ModalUpdateImages
          isOpen={openModal}
          base64={previewImage}
          listHinh={listHinh || []}
          data={props}
          status={props?.status}
          callBackClose={() => setOpenModal(false)}
          callBackRefresh={callBackRefresh}
        />
      )}
      <div className="flex">
        <div>
          <Upload
            // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            onPreview={handlePreview}
            onChange={handleUpload}
            showUploadList={{ showRemoveIcon: false }}
            listType="picture-card"
            fileList={listHinh && listHinh.length > 0 ? [...listHinh].splice(0, 3) : []}
          ></Upload>
        </div>

        <div
          className={`${
            (listHinh && listHinh.length > 0) || (listHinhNew && listHinhNew.length > 0) ? 'mt-6' : 'mb-6'
          }`}
        >
          <Button
            className="bg-[#1890ff] text-white w-[100px]"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenModal();
            }}
          >
            {listHinh && listHinh.length > 3 ? `+${listHinh.length - 3} Ảnh` : 'Thêm ảnh'}
          </Button>
        </div>
      </div>
    </>
  );
}
